import { Fragment } from 'react';

/**
 * EmbeddedCaption — The line under the QR code, with the app or organisation
 * name in bold. `text` holds a `{bold}` placeholder.
 */
export default function EmbeddedCaption({
  text,
  bold,
}: {
  text: string;
  bold: string;
}) {
  const parts = text.split('{bold}');

  return (
    <p className="mt-3 text-center text-muted-foreground">
      {parts.map((part, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <strong className="font-semibold text-foreground">{bold}</strong>
          )}
          {part}
        </Fragment>
      ))}
    </p>
  );
}
